const scene = "syllabus/";

export const UPDATE_SYLLABUS = `${scene}UPDATE_SYLLABUS`;
export const UPDATE_FILTER = `${scene}UPDATE_FILTER`;
export const UPDATE_REDUCER = `${scene}UPDATE_REDUCER`;
